import Repository from "./Repository";

const CREATE = "/create";
const DELETE = "/delete";
const EDIT = "/edit";
const SENT_EMAIL = "email/sent";
const GET_ALL = "";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  delete(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
  edit(payload) {
    return Repository.post(transformRoute(EDIT), payload);
  },
  get_all(payload) {
    return Repository.post(transformRoute(GET_ALL), payload);
  },
  sent_email(payload) {
    return Repository.post(transformRoute(SENT_EMAIL), payload);
  },
};
const transformRoute = (route) => {
  return `corporate${route}`;
};
